import { render, staticRenderFns } from "./g-toast.vue?vue&type=template&id=5173604a&scoped=true"
import script from "./g-toast.vue?vue&type=script&lang=js"
export * from "./g-toast.vue?vue&type=script&lang=js"
import style0 from "./g-toast.vue?vue&type=style&index=0&id=5173604a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173604a",
  null
  
)

export default component.exports